<template>
    <div class="form-group">
        <div class="row">
            <div class="col-3">
                <div class="form-label">{{ trans['Jenis'] }}</div>
            </div>
            <div class="col-3">
                <div class="form-label">{{ trans['Nama'] }} (Malay) <span class="text-red">*</span></div>
            </div>
            <div v-if="isMultiLanguage" class="col-3">
                <div class="form-label">Name (English) <span class="text-red">*</span></div>
            </div>
            <div class="col-3">
                <div class="form-label">{{ trans['Amaun/Kuantiti'] }} (RM/unit) <span class="text-red">*</span></div>
            </div>
        </div>
        <div v-for="(campaignPackage, index) in packages" class="row" :key="index">
            <template v-if="!campaignPackage.archived_at">
                <div class="col-3 mb-4">
                    <select v-model="campaignPackage.is_open" class="custom-select" :disabled="campaignPackage.id" style="padding: 8px 16px; color:#111827;">
                         <option value="0">Fixed Amount</option>
                        <option value="1">Open Donation</option>
                    </select>
                </div>
                <div class="col-3" style="border-radius: 1px solid #848486;">
                    <input type="text" style="padding: 8px 16px" class="form-control" name="package_name_ms" v-model="campaignPackage.name['ms']" placeholder="Nama Pakej" @input="handleChange($event)">
                </div>
                <div v-if="isMultiLanguage" class="col-3" style="border-radius: 1px solid #848486; ">
                    <input type="text" style="padding: 8px 16px" class="form-control" name="package_name_en" v-model="campaignPackage.name['en']" placeholder="Nama Pakej" @input="handleChange($event)">
                </div>
                <div class="col-3" style="border-radius: 1px solid #848486; padding-right:0px;" >
                    <input v-if="campaignPackage.is_open == 0" type="number" class="form-control" style="padding: 8px 16px" name="package_amount" placeholder="RM/unit" v-model="campaignPackage.amount" :required="!campaignPackage.is_open" @input="handleChange($event)" :disabled="campaignPackage.is_open == 1">
                </div>
                <div :class="`col-3 pl-2 ${isMultiLanguage ? 'mt-2' : ''}`" v-if="campaignPackage.id">
                    <button class="btn btn-secondary" style="padding: 4px 8px; margin-top:2px; color:#818179;" v-if="!isCreatePage" @click="archivePackage(campaignPackage.id)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.4701 4.57822L13.4715 4.57959C13.4805 4.58858 13.4877 4.59928 13.4926 4.61106C13.4975 4.62285 13.5 4.63549 13.5 4.64825V4.6494V12.45C13.5 12.6394 13.4242 12.8117 13.3013 12.9379L13.3012 12.4499L13.3 5.24932L13.2999 4.7494H12.8H3.2H2.7V5.2494V12.45V12.9392C2.57637 12.8128 2.5 12.6401 2.5 12.45L2.5 4.6494L2.5 4.64825C2.49997 4.63549 2.50248 4.62285 2.50737 4.61106C2.51227 4.59928 2.51945 4.58858 2.52851 4.57959L2.52852 4.57959L2.5299 4.57821L4.3293 2.77941L4.33 2.77871C4.33908 2.76959 4.34988 2.76236 4.36177 2.75744C4.37366 2.75251 4.38641 2.74998 4.39928 2.75H4.4L11.6 2.75L11.6007 2.75C11.6136 2.74998 11.6263 2.75251 11.6382 2.75744C11.6501 2.76236 11.6609 2.7696 11.67 2.77871L11.6707 2.77941L13.4701 4.57822ZM12.8012 12.95H13.2892C13.1628 13.0736 12.9901 13.15 12.8 13.15H3.2C3.00991 13.15 2.83715 13.0736 2.71082 12.95H3.2H12.8012ZM4.6484 2.95H4.44129L4.29485 3.09645L3.69545 3.69585L2.84189 4.5494H4.049H11.951H13.1581L12.3046 3.69585L11.7052 3.09645L11.5587 2.95H11.3516H4.6484Z" fill="#818179" stroke="#818179"/>
                        <path d="M10.0001 8.00008H6.00008V6.66675H4.66675V9.33341H11.3334V6.66675H10.0001V8.00008Z" fill="#818179"/>
                        </svg> Archive
                    </button>
                </div>
                <div class="pl-2">
                   <button style="padding: 4px 8px; margin-top:2px; color:#818179;" type="button" v-if="isAddPackageClicked && index !== 0 && newlyAddedPackages.includes(campaignPackage) && packages.filter(p => !p.archived_at).length > 1" @click="removePackage(index)" class="btn btn-secondary"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style="margin-right: 2px;" fill="none">
                        <path d="M2.09998 4.3999H3.43331H14.1" stroke="#818179" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path  d="M12.8333 4.4V12.8C12.8333 13.1183 12.6929 13.4235 12.4428 13.6485C12.1928 13.8736 11.8536 14 11.5 14H4.83333C4.47971 14 4.14057 13.8736 3.89052 13.6485C3.64048 13.4235 3.5 13.1183 3.5 12.8V4.4M5.5 4.4V3.2C5.5 2.88174 5.64048 2.57652 5.89052 2.35147C6.14057 2.12643 6.47971 2 6.83333 2H9.5C9.85362 2 10.1928 2.12643 10.4428 2.35147C10.6929 2.57652 10.8333 2.88174 10.8333 3.2V4.4" stroke="#818179" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>Remove
                   </button>
                </div>
            </template>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-start">
                <button type="button" @click="addPackage()" class="btn btn-secondary px-4" style="font-size:16px; color:#111827; border-radius: 1px solid #848486;">&#43; {{ trans['Tambah Pakej'] }} </button>
            </div>
            <div v-if="errors['packages'] && errors['packages'][0]" class="col-12 mt-2 text-danger text-sm">{{ errors['packages'][0] }}</div>
        </div>

        <h5 v-if="packages.filter(p => p.archived_at).length" class="mt-6" style="font-size:14px;">Archived Package(s)</h5>    
        
        <div v-for="(campaignPackage, index) in packages.filter(p => p.archived_at)" class="row mb-4" :key="index">
            <div v-if="index == 0" class="col-12">
                <div class="row col-12">
                    <div class="col-3 pl-0">
                        <div class="form-label">{{ trans['Jenis'] }}</div>
                    </div>
                    <div class="col-3 pl-2">
                        <div class="form-label">{{ trans['Nama'] }} (Malay) <span class="text-red">*</span></div>
                    </div>
                    <div v-if="isMultiLanguage" class="col-3">
                        <div class="form-label">Name (English) <span class="text-red">*</span></div>
                    </div>
                    <div class="col-3">
                        <div class="form-label">{{ trans['Amaun/Kuantiti'] }} (RM/unit) <span class="text-red">*</span></div>
                    </div>
                </div>
           </div>
            <div class="row col-12">
                <div class="col-3">
                    <select v-model="campaignPackage.is_open" class="custom-select" disabled style="padding: 8px 16px" >
                        <option value="0">Fixed Amount</option>
                        <option value="1">Open Donation</option>
                    </select>
                </div>
                
                <div class="col-3">
                    <input type="text" style="padding: 8px 16px" class="form-control" v-model="campaignPackage.name['ms']" disabled>
                </div>
                <div v-if="isMultiLanguage" class="col-3">
                    <input type="text" style="padding: 8px 16px" class="form-control" v-model="campaignPackage.name['en']" disabled>
                </div>
                <div class="col-3" style="padding-right:0px;">
                    <input v-if="campaignPackage.is_open == 0" type="number" class="form-control" v-model="campaignPackage.amount" :required="!campaignPackage.is_open" @input="handleChange($event)" disabled>
                </div>
                <div class="col-3 pl-2" v-if="campaignPackage.id" >
                    <button class="btn btn-secondary text-muted" style="padding: 4px 8px; margin-top:2px; color:#818179;" @click="unarchivePackage(campaignPackage.id)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.3081 3.8054L13.3081 3.80544L13.3129 3.81114C13.4281 3.94624 13.5 4.13085 13.5 4.33333V12.6667C13.5 13.1239 13.1239 13.5 12.6667 13.5H3.33333C2.87614 13.5 2.5 13.1239 2.5 12.6667V4.33333C2.5 4.13085 2.57185 3.94624 2.68708 3.81114L2.68715 3.8112L2.69303 3.80404L3.61263 2.68452C3.61269 2.68445 3.61275 2.68438 3.61281 2.68431C3.70916 2.56742 3.84338 2.5 4 2.5H12C12.1582 2.5 12.2883 2.56834 12.3751 2.67761L12.375 2.67767L12.3814 2.6854L13.3081 3.8054ZM4.16 2.83333H3.92339L3.77337 3.01629L3.2267 3.68296L2.55673 4.5H3.61333H12.3933H13.4581L12.7781 3.68067L12.2247 3.014L12.0748 2.83333H11.84H4.16ZM2.83333 12.6667V13.1667H3.33333H12.6667H13.1667V12.6667V5.33333V4.83333H12.6667H3.33333H2.83333V5.33333V12.6667ZM7.53333 9.33333V8.83333H7.03333H6.54044L8 7.37377L9.45956 8.83333H8.96667H8.46667V9.33333V10.8333H7.53333V9.33333Z" fill="#818179" stroke="#818179"/></svg> Unarchive
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isCreatePage: false,
                isAddPackageClicked: false,
                newlyAddedPackages: [],
                packages: _.get(this.initPackages[0], 'name') ? this.initPackages : [{
                    name: {
                        'en': '',
                        'ms': ''
                    },
                    amount: '',
                    archived_at: '',
                    is_open: 0
                }]
            };
        },
        props: {
            lang: {
                type: String,
                default: ''
            },
            initPackages: {
                type: Array,
                default: function() { return [{}] }
            },
            modSumbangan: {
                type: String,
                default: 'pakej_tetap'
            },
            oldRequest: {
                type: [Object, Array],
                default: function() { return {} }
            },
            errors: {
                type: Object,
                default: function() { return {} }
            },
            isMultiLanguage: {
                type: Boolean
            },
            trans: {},
        },
        computed: {
        },
        methods: {
            addPackage() {
                const newPackage = {
            name: {
                'en': '',
                'ms': ''
            },
            amount: '',
            archived_at: '',
            is_open: 0
        };

        this.packages.push(newPackage);

        // Set isAddPackageClicked to true when adding a package in edit mode
        if (!this.isCreatePage) {
            this.isAddPackageClicked = true;

            // Add the newly added package to the newlyAddedPackages array
            this.newlyAddedPackages.push(newPackage);
        }
    },
    removePackage(index) {
        if (index >= 0 && index < this.packages.length) {
            const removedPackage = this.packages[index];
            this.packages.splice(index, 1);

            // Remove the package from newlyAddedPackages if it's in there
            const newlyAddedIndex = this.newlyAddedPackages.indexOf(removedPackage);
            if (newlyAddedIndex !== -1) {
                this.newlyAddedPackages.splice(newlyAddedIndex, 1);
            }
        }
    },
            handleChange(event) {
                let data = {
                    lang: this.lang,
                    packages: this.packages
                };
                this.$emit('packagesContentChange', data);
            },
            archivePackage(packageId) {
                let pkgIndex = this.packages.findIndex(p => p.id == packageId);
                (this.packages)[pkgIndex].archived_at = moment().format('YYYY-MM-DD HH:mm:ss');
                let data = {
                    lang: this.lang,
                    packages: this.packages
                };
                this.$emit('packagesContentChange', data);
            },
            unarchivePackage(packageId) {
                let pkgIndex = this.packages.findIndex(p => p.id == packageId);
                (this.packages)[pkgIndex].archived_at = '';
                let data = {
                    lang: this.lang,
                    packages: this.packages
                };
                this.$emit('packagesContentChange', data);
            }
        },
        mounted() {
        }
    }
</script>